import 'apps/survey/styles/components/instructions.scss';
import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'library/components/modal';
import SavingButton from 'library/components/saving-button';
import { skipButtonSurvey, idealModal } from 'apps/survey/services/label-instructions';

const instructionsPart1 = `Nice work! You just completed the first part of The PAIRIN Survey. Don't worry. It gets easier from here.`;
const instructionsPart2 = `The second part of the survey is optional. In it, you can review/change your selections from part one in the left column and update the right column for how you'd want to be in a perfect world. To make things easy for you, we'll pre-populate this section with your results from the first part.`;

class IdealInstructions extends React.Component {
  state = {
    saving: false
  }

  onComplete = async () => {
    this.setState({
      saving: true
    });
    await this.props.onComplete();
    this.setState({
      saving: false
    });
  }

  render() {
    const {
      active,
      onClose=()=>{}
    } = this.props;

    return (
      <Modal onClose={onClose} active={active}>
        <div className="survey-instructions-modal-wrapper">
          <div className="survey-instructions-modal">
            <div className="survey-instructions-modal-section">
              <h1>Optional Part 2</h1>
              <img src="https://assets.pairin.com/production/survey/stack-ideal.gif" />
              <p>{instructionsPart1}</p>
              <p>{instructionsPart2}</p>
              <blockquote>{'Click the "Start part 2" button below to get started or the "skip" button to submit your survey.'}</blockquote>
              <SavingButton
                autoFocus
                aria-label={`You are now in a modal, Instructions: ${idealModal}`}
                onClick={onClose}
                href="javascript:void(0)"
                className="button">
               Get Started
              </SavingButton>
              <SavingButton
                aria-label={skipButtonSurvey}
                component="a"
                onClick={this.onComplete}
                href="javascript:void(0)"
                className="button button-tertiary"
              >
                Skip
              </SavingButton>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

IdealInstructions.propTypes = {
  active: PropTypes.bool,
  onClose: PropTypes.func,
  onComplete: PropTypes.func
};

export default IdealInstructions;
